"use strict";
var controller = function($scope, $uibModalInstance, $q, $http, $timeout, deleteParams) {
  $scope.delete = function() {
    var params = {};
    $http.delete('/api/thesaurus/' + $scope.name + '/term/' + encodeURIComponent($scope.id + '.json'), {params: params}).success(function(data, status, headers, config) {
      $scope.loading = true;
      $scope.response = data;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
      window.location = '/thesaurus/' + $scope.name + '?page=1';
    });
  };
  var init = function() {
    $scope.id = deleteParams.id;
    $scope.name = deleteParams.name;
  }();
};
module.exports = controller;
